/** The one confirmation toast (`state/toasts.ts`), bottom centre. */
import { useEffect } from "react";
import { useToasts } from "@/state/toasts";

/** How long a toast stays; one with an action stays longer, to reach it. */
const LINGER_MS = 6_000;
const LINGER_ACTION_MS = 10_000;

export function Toasts() {
  const current = useToasts((s) => s.current);
  const dismiss = useToasts((s) => s.dismiss);
  useEffect(() => {
    if (!current) return;
    const timer = setTimeout(() => dismiss(current.id), current.action ? LINGER_ACTION_MS : LINGER_MS);
    return () => clearTimeout(timer);
  }, [current, dismiss]);
  if (!current) return null;
  return (
    <div
      role={current.error ? "alert" : "status"}
      className={`fixed bottom-[calc(16px+env(safe-area-inset-bottom,0px))] left-1/2 z-50 flex max-w-[calc(100vw-32px)] -translate-x-1/2 items-center gap-3 rounded px-3 py-1.5 text-[11px] shadow-lg ${
        current.error ? "border border-danger bg-bg-elev text-fg" : "bg-fg text-bg"
      }`}
    >
      <span className="min-w-0">{current.text}</span>
      {current.action && (
        <button
          type="button"
          className="shrink-0 underline"
          onClick={() => {
            current.action?.run();
            dismiss(current.id);
          }}
        >
          {current.action.label}
        </button>
      )}
      <button
        type="button"
        className="shrink-0 opacity-70 hover:opacity-100"
        aria-label="dismiss"
        onClick={() => dismiss(current.id)}
      >
        ×
      </button>
    </div>
  );
}
